const topics = [
  { name: '#斗罗大陆新话', heat: '980万' },
  { name: '#国漫推荐', heat: '765万' },
  { name: '#下拉式阅读', heat: '642万' },
  { name: '#完美世界更新', heat: '589万' },
  { name: '#免费漫画', heat: '534万' },
  { name: '#吞噬星空', heat: '478万' },
  { name: '#仙王日常', heat: '412万' },
  { name: '#大王饶命', heat: '387万' },
  { name: '#全职高手', heat: '356万' },
  { name: '#在线看漫画', heat: '321万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">读者正在热议的漫画话题</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-[800px] mx-auto">
          {topics.map((topic) => (
            <span
              key={topic.name}
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-full cursor-pointer hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 group"
            >
              <span className="text-sm text-foreground-800 group-hover:text-primary-600 transition-colors">{topic.name}</span>
              <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded-full">{topic.heat}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}